var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image)?_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"img-fluid object-fit-cover",class:{ large: _vm.bigImage, small: !_vm.bigImage },attrs:{"data-src":_vm.image,"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }